import { ServicePage } from '@/components/ui/page-templates/ServicePage';

export function OperationsConsultingPage() {
  const breadcrumbs = [
    { label: "Services", href: "/services" },
    { label: "Consulting", href: "/services/consulting" },
    { label: "Operations Efficiency", href: "/services/consulting/operations", current: true }
  ];

  return (
    <ServicePage
      title="Operations Efficiency"
      description="Raising efficiency in operations through process improvement, automation, and scalable frameworks."
      breadcrumbs={breadcrumbs}
      category="Professional Services"
      accentColor="#1e293b"
    >
      <div className="prose dark:prose-invert max-w-none">
        <p>We help businesses streamline operations, reduce waste, and scale efficiently. Our team works with you to identify bottlenecks, implement best practices, and build sustainable operational frameworks.</p>
      </div>
    </ServicePage>
  );
}
